// extracted by mini-css-extract-plugin
export default {"logo":"Register_logo__wiPrI","logoAndAppNameContainer":"Register_logoAndAppNameContainer__Qt5QM","appName":"Register_appName__bMC2y"};